import {HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {ModalModule} from 'ngx-bootstrap/modal';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {QuillModule} from 'ngx-quill';

import {SharedModule} from '../../shared/shared.module';
import {CasePersonService} from '../people/case-person.service';
import {CaseVehicleService} from './case-vehicle.service';
import {CaseVehicleCreateComponent} from './create/create.component';
import {CaseVehicleEditComponent} from './edit/edit.component';
import {CaseVehicleFormComponent} from './form/form.component';
import {CaseVehicleListComponent} from './list/list.component';

@NgModule({
  declarations: [
    CaseVehicleFormComponent,
    CaseVehicleCreateComponent,
    CaseVehicleEditComponent,
    CaseVehicleListComponent,
  ],
  imports: [
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    QuillModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
  ],
  exports: [CaseVehicleListComponent],
  providers: [CaseVehicleService, CasePersonService],
})
export class CaseVehicleRoutingModule {}
